import type { HomePageVariant } from '@/interface/home-pages';

export const HOME_PAGES_V1 = { key: 'home-v1', cta: 'teste', visual: 'app' } as const satisfies HomePageVariant;
